interface ReferenceSectionProps {
  title: string;
  children: React.ReactNode;
  referenceRef: React.RefObject<HTMLDivElement>;
}

export function ReferenceSection({
  title,
  children,
  referenceRef,
}: ReferenceSectionProps) {
  return (
    <div className="flex flex-col border-r border-secondary">
      <h2 className="w-full bg-secondary px-4 py-3 text-sm font-medium">
        {title}
      </h2>
      <div
        ref={referenceRef}
        className="overflow-y-auto p-4"
        style={{ height: `200px` }}
      >
        {children}
      </div>
    </div>
  );
}
